<template>
  <vue-custom-scrollbar style="height: calc(100vh - 105px);">
    <ul class="sidebar-nav pd-b-10">
      <li
        :class="
          `nav-crse ${
            $route.name == 'lmsCourseView' && $route.params.bid == 0 && $route.params.bot >= 0 
              ? 'curr bd-l bd-5 bd-primary'
              : 'pd-l-10'
          }`
        "
      >
        <router-link
          :to="{
            name: 'lmsCourseView',
            params: { id: course.id, bid: 0, iid: 0, bot: 0 }
          }"
          class="nav-link lesson-title pd-10-f"
          role="button"
        >
          <!-- <feather
            type="folder"
            class="ht-20-f wd-20-f mg-r-5 tx-color-03"
          ></feather> -->
          <div
            style="width: 6px; height: 6px"
            :class="`rounded-circle bg-primary mg-r-10`"
          ></div>
          Хичээлийн агуулга
        </router-link>
      </li>
      <li
        class="nav-item mg-t-1-f"
        :class="
          `${l.id == curLessonId ? 'show' : ''} ${
            l.id == curLessonId && $route.name != 'lmsCourseView' ? 'curr' : ''
          } ${
            l.id == curLessonId && $route.name != 'lmsCourseView'
              ? 'bd-l bd-5 bd-primary'
              : ''
          }`
        "
        v-for="(l, i) in lessons"
        :key="i"
      >
        <a
          @click="openLesson(l)"
          :class="
            `nav-link with-sub lesson-title pd-y-10-f ${
              l.id == curLessonId
                ? 'pd-l-15-f pd-r-20-f'
                : 'pd-x-20-f tx-color-03'
            }`
          "
          role="button"
        >
          <div
            style="width: 6px; height: 6px"
            :class="
              `rounded-circle ${
                l.id == curLessonId ? 'bg-primary' : 'bg-secondary'
              } mg-r-10`
            "
          ></div>
          <div class="wd-80p font-weight-bold">{{ l.title }}</div>
          <div class="tx-rubik mg-x-5 tx-11">
            {{ l.percent.completedItemCount }}/{{ l.percent.itemCount }}
          </div>
        </a>
        <div v-for="(b, bi) in l.boxes" :key="bi" class="pd-x-10 lms-nav-box">
          <!-- <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">{{b.nm}}</label> -->
          <label
            v-if="l.boxes.length > 1 && course.option.hideBoxName!=1"
            class="box-title pd-l-30 pd-x-10 pd-y-10 tx-color-03 tx-13"
            >{{ b.nm }}</label
          >
          <Timeline class="mg-l-20 lms-nav-tree">
            <!-- <TimelineItem :icon="el-icon-more">
              {{ b.nm }}
            </TimelineItem> -->

            <TimelineItem
              :class="{
                'tree-item-actve': a.id == $route.params.iid,
                'is-viewed':
                  a.isViewed != undefined && a.isViewed && !a.isCompleted,
                'un-completed': a.isCompleted != undefined && a.isCompleted
              }"
              v-for="(a, ai) in getBoxItems(b)"
              :key="ai"
            >
              <!-- {{l.id}}, {{course.id}} -->
              <router-link
                :to="{
                  name: 'lmsLessonView',
                  params: {
                    id: l.id,
                    cid: course.id,
                    bid: b.id,
                    iid: a.id,
                    bot: b.ot
                  }
                }"
                class="d-flex"
                :class="{ active: a.id == $route.params.iid }"
                role="button"
              >
                <div
                  @click.stop="a.isViewed = true"
                  class="tx-color-02 lh-1"
                  v-if="b.attaches.length"
                >
                  <span class="tx-12 tx-color-02"
                    >{{ displayFormat(a.e) }}:
                  </span>
                  <span style="word-break: break-word;">{{
                    a.t != "" ? a.t : a.n
                  }}</span>
                </div>
                <div
                  @click.stop="a.isViewed = true"
                  class="tx-color-02 lh-1"
                  v-else-if="b.forms.length"
                >
                  <span v-show="a.flag == 500" class="tx-12 tx-color-02"
                    >Шалгалт:
                  </span>
                  <span v-show="a.flag == 800" class="tx-12 tx-color-02"
                    >Дасгал:
                  </span>
                  <span style="word-break: break-word;">{{ a.nm }}</span>
                </div>
                <div
                  @click.stop="a.isViewed = true"
                  class="tx-color-02 lh-1"
                  v-else-if="b.tasks.length"
                >
                  <span v-show="a.objectTypeId == 122" class="tx-12 tx-color-02"
                    >Видео:
                  </span>
                  <span style="word-break: break-word;">{{ a.task }}</span>
                </div>
                <span
                  v-if="b.attaches.length"
                  class="mg-l-auto mg-r-10 tx-10 inf rounded pd-x-8 pd-y-3"
                  >{{
                    a.dur != null && a.dur != ""
                      ? displayFormat(a.e) == "Видео"
                        ? (a.dur / 60).toFixed(0).padStart(2, "0") +
                          ":" +
                          (a.dur % 60).toFixed(0).padStart(2, "0")
                        : a.dur + "мин"
                      : ""
                  }}
                </span>
                <span
                  v-if="b.forms.length"
                  class="mg-l-auto mg-r-10 tx-10 inf rounded pd-x-8 pd-y-3"
                  >{{ a.qCount }} асуулт</span
                >
              </router-link>
            </TimelineItem>
          </Timeline>
        </div>
      </li>

      <li v-if="courseRdy &&  course.boxes.filter(x=>x.objectTypeId==503).length>0"
        :class="
          `nav-crse ${
            $route.name == 'lmsCourseView' && $route.params.bid== course.boxes.filter(x=>x.objectTypeId==503)[0]['id']
              ? 'curr bd-l bd-5 bd-primary'
              : 'pd-l-10'
          }`
        "
      >
        <router-link
          :to="{
            name: 'lmsCourseView',
            params: { id: course.id, bid: course.boxes.filter(x=>x.objectTypeId==503)[0]['id'], iid: 0, bot: 503 }
          }"
          class="nav-link lesson-title pd-10-f"
          role="button"
        >
          <div
            style="width: 6px; height: 6px"
            :class="`rounded-circle bg-primary mg-r-10`"
          ></div>
          {{course.boxes.filter(x=>x.objectTypeId==503)[0]['nm']}}
        </router-link>
      </li>

      <li  v-if="course.i6 != undefined && course.i6==1"
        :class="
          `nav-crse ${
            ($route.name == 'lmsCourseView' && $route.params.bot== -7)
              ? 'curr bd-l bd-5 bd-primary'
              : 'pd-l-10'
          }`
        "
      >
        <router-link
          :to="{
            name: 'lmsCourseView',
            params: { id: course.id, bid: 0, iid: 0, bot: -7 }
          }"
          class="nav-link lesson-title pd-10-f"
          role="button"
        >
          <div
            style="width: 6px; height: 6px"
            :class="`rounded-circle bg-primary mg-r-10`"
          ></div>
          Сертификат
        </router-link>
      </li>
    </ul>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Timeline, TimelineItem } from "element-ui";
import { getFileMode } from "@/libs/tools";

export default {
  components: {
    vueCustomScrollbar,
    Timeline,
    TimelineItem
  },
  props: {
    hasCourseObj: {
      type: Boolean,
      default: () => false
    },
    courseData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      course: {},
      courseRdy: false,
      lessons: [],
      curLessonId: 0,
      lesson: {}
    };
  },
  mounted() {
    this.init();

    //   let lb=this.course.boxes.filter(x=>x.ot==114);
    //   if(lb.length){
    //       console.log(this.course.boxes);
    //       this.lessons= lb[0].tasks.map(t=>{
    //       return { id: t.id, title: t.nm }
    //    });
    //   }
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      let self = this;
      this.toggleBodyClass("addClass", "dynamic-locker");

      //console.log('hasCourseObj', this.hasCourseObj);
      if (this.hasCourseObj) {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        this.course = this.courseData;
        this.fetchCourseAfter();
      } else {
        request({
          api: { method: "GET", url: "V2/Learn/courseDetail" },
          params: {
            id:
              self.$route.name == "lmsLessonView"
                ? this.$route.params.cid
                : this.$route.params.id
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.$emit("on-course", res.data.course);
            this.course = res.data.course;
            this.fetchCourseAfter();
          }
        });
      }
    },
    fetchCourseAfter() {
      let self = this;
      this.course.boxes.map(b => {
        if (b.ot == 114) {
          if (b.tasks.length) {
            if (this.$store.state.app.isMobile) {
              b.tasks
                .filter(x => x.i2 == 0)
                .forEach(t => {
                  //console.log('t', t);
                  self.lessons.push({
                    id: t.id,
                    title: t.task,
                    boxes: [],
                    percent: t.percent
                  });
                });
            } else {
              b.tasks.forEach(t => {
                //console.log('t', t);
                self.lessons.push({
                  id: t.id,
                  title: t.task,
                  boxes: [],
                  percent: t.percent
                });
              });
            }
            if (self.$route.name == "lmsLessonView") {
              self.initLesson(
                self.lessons.filter(x => x.id == self.$route.params.id)[0]
              );
            } else {
              //self.initLesson(self.lessons[0]);
            }
          }
        }
      });

      this.courseRdy= true;
    },
    initLesson(lesson) {
      //console.log('initLesson=> ', lesson);
      this.curLessonId = lesson.id;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/lessonDetail" },
        params: {
          id: lesson.id,
          cid: this.course.id,
          isMobile: this.$store.state.app.isMobile
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.lesson = res.data.lesson;
          this.lessons.filter(
            x => x.id == lesson.id
          )[0].boxes = res.data.lesson.boxes.filter(
            x => x.attaches.length || x.tasks.length || x.forms.length
          );
          //lesson.boxes= res.data.lesson.boxes.filter(x=>x.attaches.length || x.tasks.length || x.forms.length);
          this.lessons
            .filter(x => x.id != lesson.id)
            .forEach(x => {
              x.boxes = [];
            });
        }
      });
    },
    getBoxItems(b) {
      if (b.attaches.length) return b.attaches;
      else if (b.tasks.length) return b.tasks;
      else if (b.forms.length) return b.forms;
    },
    openLesson(l) {
      //console.log('openLesson');
      if (this.curLessonId != l.id) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "GET", url: "learn/lessonDetail" },
          params: {
            id: l.id,
            cid: this.course.id,
            isMobile: this.$store.state.app.isMobile
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            if (res.result == 0) {
              this.$emit("on-rebuy", l);
            } else {
              let b = res.data.lesson.boxes;
              if (
                b.length &&
                b.filter(
                  x => x.attaches.length || x.tasks.length || x.forms.length
                )
              ) {
                this.$emit("on-course", this.course);
                this.initLesson(l);
                if (b[0].attaches.length) {
                  this.$router.push({
                    name: "lmsLessonView",
                    params: {
                      id: l.id,
                      cid: this.course.id,
                      bid: b[0].id,
                      iid: b[0].attaches[0].id,
                      bot: b[0].ot
                    }
                  });
                } else if (b[0].tasks.length) {
                  this.$router.push({
                    name: "lmsLessonView",
                    params: {
                      id: l.id,
                      cid: this.course.id,
                      bid: b[0].id,
                      iid: b[0].tasks[0].id,
                      bot: b[0].ot
                    }
                  });
                } else if (b[0].forms.length) {
                  this.$router.push({
                    name: "lmsLessonView",
                    params: {
                      id: l.id,
                      cid: this.course.id,
                      bid: b[0].id,
                      iid: b[0].forms[0].id,
                      bot: b[0].ot
                    }
                  });
                }
              } else {
                Notification.info({
                  message: "Хичээл хоосон байна.",
                  duration: 5000,
                  type: "info",
                  position: "bottom-left",
                  offset: 50
                });
              }
            }
            //lesson.boxes= res.data.lesson.boxes.filter(x=>x.attaches.length || x.tasks.length || x.forms.length);
          } else {
            //console.log('on-rebuy hiidee', l);
            //this.$emit('on-rebuy', l);
          }
        });
      }
    },
    updateCompleted() {
      //console.log('updateCompleted fired');
      var lesson_cur_index = this.lessons.findIndex(
        x => x.id == this.$route.params.id
      );
      var box_cur_index = this.lessons[lesson_cur_index].boxes.findIndex(
        x => x.id == this.$route.params.bid
      );
      if (this.lessons[lesson_cur_index].boxes[box_cur_index].attaches.length) {
        if (
          !this.lessons[lesson_cur_index].boxes[box_cur_index].attaches.filter(
            x => x.id == this.$route.params.iid
          )[0].isCompleted
        ) {
          this.lessons[lesson_cur_index]["percent"]["completedItemCount"]++;
        }
        this.lessons[lesson_cur_index].boxes[box_cur_index].attaches.filter(
          x => x.id == this.$route.params.iid
        )[0].isCompleted = true;
      } else if (
        this.lessons[lesson_cur_index].boxes[box_cur_index].forms.length
      ) {
        this.lessons[lesson_cur_index].boxes[box_cur_index].forms.filter(
          x => x.id == this.$route.params.iid
        )[0].isCompleted = true;
      }
    },
    prevOrNextContent(e) {
      //uragshaa yavj bgaa yed
      //ehnii hicheeliin ehnii content bol msg ugnu
      //2 dahi hicheeliin ehnii content bol umnuh hicheeliin suuliin content neene
      //2 dahi hairtsgiin ehnii content bol umnu hairtsagnii svvliin content neeh

      var lesson_cur_index = this.lessons.findIndex(
        x => x.id == this.curLessonId
      );
      var box_cur_index = this.lessons[lesson_cur_index].boxes.findIndex(
        x => x.id == this.$route.params.bid
      );
      var item_cur_index = null;
      let objs = "";
      if (this.lessons[lesson_cur_index].boxes[box_cur_index].attaches.length) {
        objs = "attaches";
        item_cur_index = this.lessons[lesson_cur_index].boxes[
          box_cur_index
        ].attaches.findIndex(x => x.id == this.$route.params.iid);
        if (item_cur_index > 0) {
          this.lessons[lesson_cur_index].boxes[box_cur_index].attaches[
            item_cur_index
          ].isViewed = true;
        }
      } else if (
        this.lessons[lesson_cur_index].boxes[box_cur_index].forms.length
      ) {
        objs = "forms";
        item_cur_index = this.lessons[lesson_cur_index].boxes[
          box_cur_index
        ].forms.findIndex(x => x.id == this.$route.params.iid);

        if (item_cur_index > 0) {
          this.lessons[lesson_cur_index].boxes[box_cur_index].forms[
            item_cur_index
          ].isViewed = true;
        }
      } else if (
        this.lessons[lesson_cur_index].boxes[box_cur_index].tasks.length
      ) {
        objs = "tasks";
        item_cur_index = this.lessons[lesson_cur_index].boxes[
          box_cur_index
        ].tasks.findIndex(x => x.id == this.$route.params.iid);

        if (item_cur_index > 0) {
          this.lessons[lesson_cur_index].boxes[box_cur_index].tasks[
            item_cur_index
          ].isViewed = true;
        }
      }

      //console.log(lesson_cur_index, box_cur_index, item_cur_index);
      let bid = 0;
      let bot = 0;
      let iid = 0;
      let lid = 0;
      if (e.mode == -1) {
        if (
          lesson_cur_index == 0 &&
          box_cur_index == 0 &&
          item_cur_index == 0
        ) {
          Notification.info({
            message: "Эхний контент байна.",
            duration: 5000,
            type: "info",
            position: "bottom-left",
            offset: 50
          });
        } else if (item_cur_index > 0) {
          lid = this.lessons[lesson_cur_index]["id"];
          bid = this.lessons[lesson_cur_index].boxes[box_cur_index]["id"];
          bot = this.lessons[lesson_cur_index].boxes[box_cur_index]["ot"];
          iid = this.lessons[lesson_cur_index].boxes[box_cur_index][objs][
            item_cur_index + e.mode
          ]["id"];

          this.lessons[lesson_cur_index].boxes[box_cur_index][objs][
            item_cur_index + e.mode
          ]["isViewed"] = true;
          //umnuh content ruu yavna
        } else if (box_cur_index > 0 && item_cur_index == 0) {
          lid = this.lessons[lesson_cur_index]["id"];
          bid = this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
            "id"
          ];
          bot = this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
            "ot"
          ];
          let lngth = 0;
          let befobj = "";
          if (
            this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
              "attaches"
            ].length
          ) {
            befobj = "attaches";
            lngth = this.lessons[lesson_cur_index].boxes[
              box_cur_index + e.mode
            ]["attaches"].length;
          } else if (
            this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
              "forms"
            ].length
          ) {
            befobj = "forms";
            lngth = this.lessons[lesson_cur_index].boxes[
              box_cur_index + e.mode
            ]["forms"].length;
          } else if (
            this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
              "tasks"
            ].length
          ) {
            befobj = "tasks";
            lngth = this.lessons[lesson_cur_index].boxes[
              box_cur_index + e.mode
            ]["tasks"].length;
          }
          iid = this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
            befobj
          ][lngth - 1]["id"];

          this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][befobj][
            lngth - 1
          ]["isViewed"] = true;
          //umnuh hairtsag suuliin content ruu yavna
        } else if (lesson_cur_index > 0) {
          lid = this.lessons[lesson_cur_index + e.mode]["id"];

          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "learn/lessonDetail" },
            params: {
              id: lid,
              cid: this.course.id,
              isMobile: this.$store.state.app.isMobile
            },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              let b = res.data.lesson.boxes;
              if (
                b.length &&
                b.filter(
                  x => x.attaches.length || x.tasks.length || x.forms.length
                )
              ) {
                this.curLessonId = lid;
                this.lessons.filter(
                  x => x.id == lid
                )[0].boxes = res.data.lesson.boxes.filter(
                  x => x.attaches.length || x.tasks.length || x.forms.length
                );
                this.lessons
                  .filter(x => x.id != lid)
                  .forEach(x => {
                    x.boxes = [];
                  });
                if (b[b.length - 1].attaches.length) {
                  b[b.length - 1].attaches[
                    b[b.length - 1].attaches.length - 1
                  ].isViewed = true;
                  this.$router.push({
                    name: "lmsLessonView",
                    params: {
                      id: lid,
                      cid: this.course.id,
                      bid: b[b.length - 1].id,
                      iid:
                        b[b.length - 1].attaches[
                          b[b.length - 1].attaches.length - 1
                        ].id,
                      bot: b[b.length - 1].ot
                    }
                  });
                } else if (b[b.length - 1].tasks.length) {
                  b[b.length - 1].tasks[
                    b[b.length - 1].tasks.length - 1
                  ].isViewed = true;
                  this.$router.push({
                    name: "lmsLessonView",
                    params: {
                      id: lid,
                      cid: this.course.id,
                      bid: b[b.length - 1].id,
                      iid:
                        b[b.length - 1].tasks[b[b.length - 1].tasks.length - 1]
                          .id,
                      bot: b[b.length - 1].ot
                    }
                  });
                } else if (b[b.length - 1].forms.length) {
                  b[b.length - 1].forms[
                    b[b.length - 1].forms.length - 1
                  ].isViewed = true;
                  this.$router.push({
                    name: "lmsLessonView",
                    params: {
                      id: lid,
                      cid: this.course.id,
                      bid: b[b.length - 1].id,
                      iid:
                        b[b.length - 1].forms[b[b.length - 1].forms.length - 1]
                          .id,
                      bot: b[b.length - 1].ot
                    }
                  });
                }
              }
            }
          });
        }
      } else {
        if (
          item_cur_index <
          this.lessons[lesson_cur_index].boxes[box_cur_index][objs].length - 1
        ) {
          //console.log('minii ard item bgaa');
          iid = this.lessons[lesson_cur_index].boxes[box_cur_index][objs][
            item_cur_index + e.mode
          ]["id"];

          this.lessons[lesson_cur_index].boxes[box_cur_index][objs][
            item_cur_index + e.mode
          ]["isViewed"] = true;

          lid = this.lessons[lesson_cur_index]["id"];
          bid = this.lessons[lesson_cur_index].boxes[box_cur_index]["id"];
          bot = this.lessons[lesson_cur_index].boxes[box_cur_index]["ot"];
        } else if (
          box_cur_index <
          this.lessons[lesson_cur_index].boxes.length - 1
        ) {
          lid = this.lessons[lesson_cur_index]["id"];
          bid = this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
            "id"
          ];
          bot = this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
            "ot"
          ];

          //console.log('minii ard box bgaa');

          let nextobj = "";
          if (
            this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
              "attaches"
            ].length
          ) {
            nextobj = "attaches";
          } else if (
            this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
              "forms"
            ].length
          ) {
            nextobj = "forms";
          } else if (
            this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
              "tasks"
            ].length
          ) {
            nextobj = "tasks";
          }
          iid = this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
            nextobj
          ][0]["id"];
          //console.log('end orsnuu ', this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][nextobj]);
          this.lessons[lesson_cur_index].boxes[box_cur_index + e.mode][
            nextobj
          ][0]["isViewed"] = true;
        } else if (lesson_cur_index < this.lessons.length - 1) {
          //console.log('minii ard lesson bgaa', this.lessons[lesson_cur_index+e.mode]);
          this.openLesson(this.lessons[lesson_cur_index + e.mode]);
        } else {
          //console.log('suuliin hicheeliin svvliin hairtsagnii svvliin content bna');
        }
      }

      if (iid > 0) {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: lid,
            cid: this.course.id,
            bid: bid,
            iid: iid,
            bot: bot
          }
        });
      }
      //console.log(lid, bid,bot, iid);
    },
    displayFormat(e) {
      let rv = "";
      if (getFileMode(e) == "document" || getFileMode(e) == "pdfObject") {
        rv = "Унших";
      } else if (getFileMode(e) == "video") {
        rv = "Видео";
      } else if (getFileMode(e) == "image") {
        rv = "Зураг";
      } else if (e == "mp3") rv = "Аудио";
      else rv = e;

      return rv;
    }
  }
};
</script>

<style></style>
